import type { RouterOptions } from "@nuxt/schema";
import { subdomainMap } from "~/subdomains";

export default <RouterOptions>{
  routes: (_routes) => {
    const urlObj = useRequestURL();
    const subdomainObj = subdomainMap.get(urlObj.host);

    if (subdomainObj) {
      const newRoutes = _routes.filter((route) => route.name !== "index");
      const userRouteMapped = newRoutes.map((i) => ({
        ...i,
        path:
          i.path === `${subdomainObj?.baseUrl}`
            ? i.path.replace(`${subdomainObj?.baseUrl}`, "/")
            : i.path.replace(`${subdomainObj?.baseUrl}/`, "/"),
      }));
      return userRouteMapped;
    }
  },
  scrollBehavior: async (to, _from, savedPosition) => {
    if (to.hash) {
      return new Promise((resolve) => {
        const check = {
          timeout: 2000,
          frequency: 100,
          start: performance.now(),
          counter: 0,
        };

        const checkExist = () => {
          check.counter++;
          const el = document.querySelector(to.hash);
          if (el) {
            resolve({
              el: to.hash,
              top: 30,
              behavior: "smooth",
            });
          } else if (performance.now() - check.start < check.timeout) {
            setTimeout(checkExist, check.frequency + check.counter);
          } else {
            // Fallback if element does not appear after timeout exceeded.
            resolve({ top: 0, behavior: "smooth" });
          }
        };

        checkExist();
      });
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: "smooth" };
    }
  },
};
